import { JobListResponse } from '@doda/api-client/aspida/@types';
import { FetchBaseStateType } from '@doda/common/src/interfaces/fetchBaseState';
import { createSlice } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '@doda/common/src/constants/loadingStatus';
import { getJobListForTrendHolidayAndWayOfWorking } from '@doda/common/src/services/getJobListForTrendAPI';

type JobSearchListEntityType = FetchBaseStateType<JobListResponse>;

/**
 * 初期型
 * @param jobRecommendListForTrend 取得求人一覧
 * @param initialDisplayFlag 初期表示判定フラグ
 */
export interface JobRecommendListForTrendHolidayAndWayOfWorkingState {
  jobRecommendListForTrend: JobSearchListEntityType;
  initialDisplayFlag: number;
}

// 初期状態
export const jobRecommendListForTrendHolidayAndWayOfWorkingInitialState: JobRecommendListForTrendHolidayAndWayOfWorkingState =
  {
    jobRecommendListForTrend: {
      loading: LOADING_STATUS.IDLE,
      entity: { results: [] },
    },
    initialDisplayFlag: -1,
  };

export const jobRecommendListForTrendHolidayAndWayOfWorkingSlice = createSlice({
  name: 'jobRecommendListForTrendHolidayAndWayOfWorking',
  initialState: jobRecommendListForTrendHolidayAndWayOfWorkingInitialState,
  reducers: {
    setInitialDisplayFlagHolidayAndWayOfWorking: (state, action) => {
      state.initialDisplayFlag = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getJobListForTrendHolidayAndWayOfWorking.pending,
      (state) => {
        state.jobRecommendListForTrend.loading = LOADING_STATUS.PENDING;
      }
    );
    builder.addCase(
      getJobListForTrendHolidayAndWayOfWorking.fulfilled,
      (state, action) => {
        state.jobRecommendListForTrend.loading = LOADING_STATUS.SUCCESS;
        state.jobRecommendListForTrend.entity = action.payload;
      }
    );
    builder.addCase(
      getJobListForTrendHolidayAndWayOfWorking.rejected,
      (state) => {
        state.jobRecommendListForTrend.loading = LOADING_STATUS.ERROR;
      }
    );
  },
});

// Create Action
export const { setInitialDisplayFlagHolidayAndWayOfWorking } =
  jobRecommendListForTrendHolidayAndWayOfWorkingSlice.actions;

// reducer
export const jobRecommendListForTrendHolidayAndWayOfWorkingReducer =
  jobRecommendListForTrendHolidayAndWayOfWorkingSlice.reducer;

interface State {
  jobRecommendListForTrendHolidayAndWayOfWorking: JobRecommendListForTrendHolidayAndWayOfWorkingState;
}

/**
 * ローディングSelector
 * @param state
 * @returns 状態
 */
export const jobRecommendListForTrendHolidayAndWayOfWorkingLoadingSelector = <
  S extends State,
>(
  state: S
) =>
  state.jobRecommendListForTrendHolidayAndWayOfWorking?.jobRecommendListForTrend
    .loading;

/**
 * 求人一覧Selector
 * @param state
 * @returns 求人一覧
 */
export const jobRecommendListForTrendHolidayAndWayOfWorkingEntitySelector = <
  S extends State,
>(
  state: S
) =>
  state.jobRecommendListForTrendHolidayAndWayOfWorking?.jobRecommendListForTrend
    .entity;

/**
 * 初期表示判定フラグSelector
 * @param state
 * @returns 初期表示判定フラグ
 */
export const initialDisplayFlagHolidayAndWayOfWorkingSelector = <
  S extends State,
>(
  state: S
) => state.jobRecommendListForTrendHolidayAndWayOfWorking.initialDisplayFlag;
